/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(){this.enabled=!1,this.fadeFactor=1}}export{t as ScreenSpaceReflectionsUniforms};
